import { api } from '@marketplace-web/core-api/core-api-client-util'

import { GetOfflineVerificationFeedbackResp } from '../types/offline-verification-feedback'

export const getOfflineVerificationFeedback = (transactionId: number) =>
  api.get<GetOfflineVerificationFeedbackResp>(
    `/transactions/${transactionId}/verification_feedbacks`,
  )
